import axios from "axios";
import {
  getRunMode,
  getUserInfoFromCookies,
  returnToLogin,
} from "src/utils/helpers/applicationHelpers";

const getAuthorizationHeader = () => {
  const userInfo = getUserInfoFromCookies();
  const runMode = getRunMode();
  if (!userInfo) {
    if (runMode !== "local") {
      returnToLogin();
    } else {
      throw new Error("Nenhuma sessão de usuário encontrada. Favor logar no Astrea");
    }
  }

  const session = userInfo.session;
  const authString = `Bearer ${session}`;
  return authString;
};

const defaultInstance = axios.create({
  baseURL: process.env.API_DOMAIN,
  headers: {
    Authorization: getAuthorizationHeader(),
  },
});

export default defaultInstance;
